<div id="sidebar">
    <div id="mySidenav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" (click)="closeSidebar()">&times;</a>
        <ul id="sidenavList">
            <ng-container *ngFor="let menu of menuItems">
                <ng-container *ngIf="menu.is_enabled">
                    <li *ngIf="!menu.is_modal">
                        <a routerLinkActive="activeLink" (click)="clickOpen(menu.path)">
                            <img src="{{menu.icon}}" alt="">
                            {{menu.name | titlecase}}
                        </a>
                      
                    </li>
                    <li *ngIf="menu.is_modal">
                        <a (click)="openModal(menu.data_target)">
                            <img src="{{menu.icon}}" alt="">
                            {{menu.name | titlecase}}
                        </a>
                        
                    </li>
                   
                </ng-container>  
                          
            </ng-container>           
        </ul>
    </div>
    <div id="hamburger" (click)="openSidebar()">&#9776;</div>
</div>
<div *ngIf="!url.url.includes('auditorium')" class="footer-nav">
    <ul *ngIf="this.url.url != '/directLogin'" class="footer-nav1">
        <ng-container *ngFor="let menu of menuItems">
            <ng-container *ngIf="menu.is_enabled">
                <li *ngIf="!menu.is_modal">
                    <a routerLinkActive="activeLink" (click)="clickOpen(menu.path)">
                        <img src="{{menu.icon}}" alt="">
                        <div>{{menu.name | uppercase}}</div>
                    </a>
                </li>
                <li *ngIf="menu.is_modal">
                    <a (click)="openModal(menu.data_target)">
                        <img src="{{menu.icon}}" alt="">
                        <div>{{menu.name | uppercase}}</div>
                    </a>
                </li>
            </ng-container>
        </ng-container>
    </ul>
</div>


<div class="modal fade" id="feedback_modal" tabindex="-1" aria-labelledby="pdf_modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">      
        <div class="modal-body p-0">
          <div id="modal_popup">
              <div id="close_modal_popup" (click)="closeModal()">&times;</div>    
              <div class="modal-header bg-primary text-white">
                  <h5 class="modal-title" id="pdf_modalLabel">Feedback</h5>
              </div>
              <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12 col-xl-12 p-0" style="text-align: center;">
                        <div>
                            <iframe  frameborder="0" height="550" src="https://forms.gle/bJLEsiJUpLHgx4vn6" width="100%"></iframe>                              
                          </div>
                    </div>
                  </div>
              </div>
          </div>      
        </div>      
      </div>
    </div>
  </div>
